import { Component, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

export class DialogData {
  Version: string;
  BuildNumber: string;
  DateOfBuild: string;
  SinequaURL: string;
}

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['../nav-bar/nav-bar.component.css']
})
export class AboutComponent {

  constructor(
    @Optional() public dialogRef: MatDialogRef<AboutComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }
  ngOnInit() {
    if (this.data == null) {
      this.data = new DialogData();
    }
  }
  // close the dialog
  onNoClick(): void {
    this.dialogRef.close();
  }
}
